import { render, staticRenderFns } from "./BulkCallAdjustmentForm.vue?vue&type=template&id=52c48e16"
import script from "./BulkCallAdjustmentForm.vue?vue&type=script&lang=js"
export * from "./BulkCallAdjustmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports